import React from 'react'

import { Navbar, Nav } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faCode } from '@fortawesome/free-solid-svg-icons'

export class AppNavbar extends React.Component {
  render () {
    return (
      <Navbar bg='dark' variant='dark' expand='lg'>
        <Navbar.Brand>
        <FontAwesomeIcon icon={faCode} className="mr-2"/> JSON 2 TypeScript
        </Navbar.Brand>
        <Nav className='mr-auto'>
          <Nav.Link
            href='https://github.com/michelefenu/json2interface'
            target='_blank'
            rel='noopener noreferrer'
          >
            &#123; version 0.1.13 &#125;
          </Nav.Link>
        </Nav>
      </Navbar>
    )
  }
}

export default AppNavbar
